export default {
      id: "ic_large_search-usage",
      viewBox: "0 0 30 30",
      url: "/" + "images/icons.3.109.2.svg#ic_large_search-usage",
      toString: function () {
        return this.url;
      }
    }